var map = {
	"./webspecial_food_curry_cn.mp4": 8782,
	"./webspecial_food_curry_de.mp4": 5247,
	"./webspecial_food_curry_en.mp4": 1208,
	"./webspecial_food_curry_ja.mp4": 1642,
	"./webspecial_food_curry_tr.mp4": 7311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1872;